export const LOGIN = '/'
export const CONDITION_DETAIL = '/conditionDetail'
// 分类详情
export const CLASSIFICATION_DETAIL = '/classificationDetail'
// 数据集列表
export const DATA_SET_LIST = '/dataSetList'
// 数据集详细
export const DATA_SET_DETAIL = '/dataSetDetail'
// 我的应用
export const MY_APPLICATION = '/myApplication'
// 我的洞察
export const MY_INSIGHT = '/myInsight'
// 客户档案
export const CUSTOMER_DOCUMENT = '/customerDocument'
// 工作流
export const WORK_INFO = '/workInfo'
// 统计报表
export const TOTAL_TABLE = '/totalTable'
// 权限管理
export const POWER_MANAGE = '/powerManage'
// 账号管理
export const ACCOUNT_MANAGEMENT = '/accountManagement'
// 基础信息管理
export const BASE_INFO_MANAGE = '/baseInfoManage'
// DMS数据同步
export const DMS_DATA_MANAGE = '/dmsDataManage'
export const TEST = '/loading'
// 修改模型
export const MODIFY_MODEL = '/modifyModel'
// 预约列表
export const MAKE_AN_APPOINTMENT_LIST = '/makeAnAppointmentList'
// 预约进店统计
export const APPOINTMENT_TO_SHOP = '/appointmentToShop'
// 首保回厂率统计
export const FIRST_GUARANTEE_TO_SHOP = '/firstGuaranteeToShop'
// 忠诚度统计
export const LOYALTY_STATISTICS = '/loyaltyStatistics'
// 预约活动记录
export const ACTIVITY_TO_BE_INTERVIEWED = '/activityToBeInterviewed'
// 续保电话统计
export const TELEPHONE_STATISTICS = '/telephoneStatistics'
// 售后结算统计
export const SALE_SETTLEMENT_STATISTICS = '/saleSettlementStatistics'
// 售后工时费统计
export const SALE_HOURS_STATISTICS = '/saleHoursStatistics'
// 公众号跳转中心
export const ROUTER_CENTER = '/sso'
// 微信会员-个人中心
export const WX_PERSONAL_CENTER = '/wxmember/personalCenter'
// 微信会员-个人详情
export const WX_PERSONAL_DETAIL = '/wxmember/personalDetail'
// 微信会员-消费记录
export const CONSUMPTION_RECORD = '/wxmember/consumptionRecord'
// 微信会员-我的卡券
export const MY_COUPON = '/wxmember/myCoupon'
// 微信会员-核销记录
export const CANCEL_RECORD = '/wxmember/cancelRecord'
// 微信会员-发起预约
export const CREATE_MAKE_AN_APPOINTMENT = '/wxmember/createMakeAnAppointment'
// 外出-核销
export const WRITE_OFF_OPERATION = '/wxmember/writeOffOperation'
// 外出-记录
export const GO_OUT_MY_RECORD = '/wxmember/goOutMyRecord'
// 外出-卡劵详情
export const GO_OUT_COUPON_INFO_DETAIL = '/wxmember/getCouponInfoById'
// 外出-认证审核
export const CERTIFICATION_AUDIT_VIEW = '/wxmember/certificationAudit'
// 外出-认证审核详情
export const CERTIFICATION_DETAIL = '/wxmember/certificationDetail'
// 外出-卡券操作
export const CARD_OPERATION_SEARCH = '/wxmember/cardOperationSearch'
// 外出-卡券操作详情（卡券发放、卡券审核）
export const GRANT_OF_COUPON = '/wxmember/grantOfCoupon'
// 我的保险
export const MY_INSURANCE_RECORD = '/wxmember/myInsuranceRecord'
// 我的储值记录
export const MY_STORED_VALUE_RECORD = '/wxmember/myStoredValueRecord'
// 积分商城 商城主页
export const POINTS_MAIL_HOME_PAGE = '/wxmember/pointsMailHomePage'
// 积分商城 商品详情
export const PRODUCT_DETAILS = '/wxmember/productDetails'
// 积分商城 商品搜索
export const PRODUCT_SEARCH = '/wxmember/productSearch'
// 积分商城 兑换记录
export const EXCHANGE_RECORD = '/wxmember/exchangeRecord'
// 积分商城 我的积分
export const MY_POINTS = '/wxmember/myPoints'
// 积分商城 等级权益
export const RANK_EQUITY = '/wxmember/rankEquity'
// 积分商城 全部等级权益
export const RANK_EQUITY_DETAILS = '/wxmember/rankEquityDetails'
// 积分商城 订单页面
export const PRODUCT_ORDER = '/wxmember/productOrder'
// 积分商城 支付详情
export const PAYMENT_DETAILS = '/wxmember/paymentDetails'
// 积分商城 购物车
export const SHOPPTING_CART = '/wxmember/shopptingCart'
// 积分商城 收银台
export const POINTS_MAIL_CASHIER = '/wxmember/pointsMailCashier'
// 积分商城 消费记录
export const RECORDS_OF_CONSUMPTION = '/wxmember/recordsOfConsumption'
// 积分商城 我的订单
export const MY_ORDER = '/wxmember/myOrder'
// 积分商城 我的订单详情
export const MY_ORDER_DETAILS = '/wxmember/myOrderDetails'
// 积分商城 我的延保 简介
export const MY_EXTENDED_INSURANCE_BRIEF_INTRODUCTION = '/wxmember/myExtendedInsuranceBriefIntroduction'
// 积分商城 我的延保
export const MY_EXTENDED_INSURANCE = '/wxmember/myExtendedInsurance'
// 积分商城 我的延保 延保条款
export const MY_EXTENDED_INSURANCE_DETAILS = '/wxmember/myExtendedInsuranceDetails'
// 积分商城 个人信息
export const PERSONAL_INFORMATION = '/wxmember/personalInformation'
// 积分商城 我的储值
export const MY_STORED_VALUE = '/wxmember/myStoredValue'
// 积分商城 我的储值 详细
export const MY_STORED_VALUE_DETAILS = '/wxmember/myStoredValueDetails'
// 积分商城 我的储值 储值卡
export const MY_STORED_VALUE_CODE = '/wxmember/myStoredValueCode'
// 积分商城 常见问题
export const COMMON_PROBLEM = '/wxmember/commonProblem'
// 积分商城 专属客服
export const EXCLUSIVE_CUSTOMER_SERVICE = '/wxmember/exclusiveCustomerService'
// 积分商城 分享
export const SHARE = '/wxmember/share'
// 积分商城 我的车辆
export const MY_CAR = '/wxmember/myCar'
// 积分商城 我的车辆
export const ADD_MY_CAR = '/wxmember/addMyCar'

// 首页
export const NEW_HOUME_PAGE = '/wxmember/home'
// 预约试驾
export const TEST_DRIVE = '/wxmember/testDrive'
// 首页 活动专区详情
export const VEENT_DETAILS = '/wxmember/veentDetails'
// 首页 优惠详情
export const DISCOUNT_DETAILS = '/wxmember/discountDetails'
// 首页 实用技巧
export const PRACTICAL_SKILLS_DETAILS = '/wxmember/practicalSkillsDetails'
// 首页 预约form
export const MAKE_AN_APPOINTMENT = '/wxmember/makeAnAppointment'

// 服务
export const PAGE_MAIL_SERVICE = '/wxmember/pageMailService'

// 一键续保
export const ONE_CLICK_RENEWAL = '/wxmember/oneClickRenewal'

// 年检代办
export const ANNUAL_INSPECTION_AGENCY = '/wxmember/annualInspectionAgency'

// 油卡充值
export const OIL_CARD_RECHARGE = '/wxmember/oilCardRecharge'

// 金融服务
export const FINANCIAL_SERVICE = '/wxmember/financialService'

// 洗车服务
export const CAR_WASH_SERVICE = '/wxmember/carWashService'

// 我的车辆
export const MY_CAR_SERVE = '/wxmember/myCarServe'
// 延保
export const EXTENDED_INSURANCE = '/wxmember/extendedInsurance'
// 优惠券
export const COUPON = '/wxmember/coupon'

// 储值钱包
export const STORED_VALUE_WALLET = '/wxmember/storedValueWallet'

// 设置
export const MYSETUP = '/wxmember/mySetUp'

// 积分兑换支付页面
export const PRODUCT_PAY = '/wxmember/productPay'

// 商品详情页面
export const COMMODITY_CLASS = '/wxmember/commodityClass'

// 商品列表
export const COMMODITY_LIST = '/wxmember/commodityList'

// 一键救援
export const ONE_CLICK_RESCUE = '/wxmember/oneClickRescue'

// 预约详情
export const CONSUMPTION_INFO = '/wxmember/consumptionInfo'

// 储值详情
export const STORED_VALUE_WALLET_INFO = '/wxmember/storedValueWalletInfo'

// 新增检测
export const NEW_DETECTION = '/wxmember/newDetection'

// 预检记录
export const PRE_INSPECTION_RECORD = '/wxmember/preInspectionRecord'

// 完工记录
export const COMPLETION_RECORD = '/wxmember/completionRecord'

// 完工记录
export const COMPLETION_MODIFICATION = '/wxmember/completionModification'



// WEBPACK FOOTER //
// ./src/constants/RoutePathConstants.js